import classNames from "classnames";
import { FC, useCallback } from "react";

import Modal from "components/Modal";

import { RootStore } from "store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { markCalibrationRequest } from "store/slices/deviceSlice";
import { hideModal } from "store/slices/modalSlice";

import ModalMarkCalibratedContent, { CalibrationDeviceInfo, CalibrationFormValues } from "./Content";

import styles from "./styles.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  devEui?: string;
  deviceInfo?: CalibrationDeviceInfo;
};

const WidgetModalMarkCalibrated: FC<PropTypes> = ({
  isVisible,
  className,
  devEui,
  deviceInfo,
}) => {
  const dispatch = useAppDispatch();
  const isCalibrating = useAppSelector((s: RootStore) => s.devices.isCalibrating);

  const handleSubmit = useCallback(
    (values: CalibrationFormValues) => {
      if (!devEui) return;
      dispatch(markCalibrationRequest({ devEui, values }));
    },
    [devEui, dispatch],
  );

  const handleClose = useCallback(() => {
    dispatch(hideModal());
  }, [dispatch]);

  return (
    <Modal
      title="Mark as calibrated"
      isClose
      isCloseBg
      isVisible={isVisible}
      className={classNames(styles.modal, className)}
    >
      <ModalMarkCalibratedContent
        deviceInfo={deviceInfo}
        onSubmit={handleSubmit}
        onClose={handleClose}
        isLoading={isCalibrating}
      />
    </Modal>
  );
};

export default WidgetModalMarkCalibrated;
